import { useMemo } from "react";
import { FinancialGoal, useHistoricValuations } from "@rentablo/api/apiv1";
import { HistoryPoint } from "../utils/goalChartData";

/** Month-end values of the goal's accounts, cash included, since its start */
export const useGoalHistory = (goal?: FinancialGoal) => {
  const accountIds = goal?.accountIds ?? [];
  const startDate = goal?.startDate?.slice(0, 10) ?? "";

  const { data, ...query } = useHistoricValuations(
    {
      id: accountIds,
      intervalType: "month",
      startDate,
      includeCash: true,
      includeCurrentValue: true,
    },
    { enabled: accountIds.length > 0 && Boolean(startDate) }
  );

  const points = useMemo(
    () =>
      (data?.dateValuePairs ?? []).flatMap(({ date, value }): HistoryPoint[] =>
        date && value !== undefined ? [{ date: date.slice(0, 10), value }] : []
      ),
    [data]
  );

  return { ...query, points };
};
